import React, { useState } from 'react';

const EmailInput = ({ 
  value = '', 
  onChange, 
  label = '电子邮箱', 
  placeholder = 'example@email.com',
  required = false,
  className = '',
  disabled = false
}) => {
  const [error, setError] = useState('');

  // 验证邮箱格式
  const validateEmail = (email) => {
    if (!email) return '';
    
    // 邮箱格式验证
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    
    if (emailRegex.test(email)) {
      return '';
    }
    
    return '请输入有效的邮箱地址格式（如：example@email.com）';
  };

  // 处理输入变化
  const handleChange = (e) => {
    const inputValue = e.target.value;
    
    // 验证格式
    const validationError = validateEmail(inputValue);
    setError(validationError);
    
    // 调用父组件的onChange
    onChange(inputValue);
  };

  // 处理失去焦点时的验证
  const handleBlur = () => {
    if (value && !error) {
      const validationError = validateEmail(value);
      setError(validationError);
    }
  };

  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      
      <div className="relative">
        <input
          type="email"
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={placeholder}
          disabled={disabled}
          className={`w-full h-12 px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 ${
            error 
              ? 'border-red-300 bg-red-50 focus:ring-red-500' 
              : 'border-gray-300 bg-gradient-to-r from-white to-blue-50 shadow-sm hover:shadow-md'
          } ${disabled ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : ''}`}
        />
        
        {/* 格式提示 */}
        {!error && value && validateEmail(value) === '' && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <div className="text-green-500">✓</div>
          </div>
        )}
      </div>
      
      {/* 错误信息 */}
      {error && (
        <p className="mt-1 text-sm text-red-600 flex items-center">
          <span className="w-4 h-4 mr-1">⚠️</span>
          {error}
        </p>
      )}
      
      {/* 帮助信息 */}
      {!error && !value && (
        <p className="mt-1 text-xs text-gray-500">
          格式：用户名@域名.com
        </p>
      )}
    </div>
  );
};

export default EmailInput; 